import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  finalizeOrder: {
    padding: '0',
    flex: 1,
    columnGap: '0',
    '@media (min-width: 640px)': {
      backgroundColor: theme.evPalette.charcoal[100],
      padding: '16px 24px',
      flex: 1,
      columnGap: '16px',
    },
  },
  finalizeOrderPanels: {
    display: 'flex',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      rowGap: theme.spacing(2),
    },
  },
  orderSummary: {
    flex: 1,
    height: 'fit-content',
    padding: '16px 24px',
  },
  orderSummaryHeading: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '27px',
    color: theme.evPalette.ocean[700],
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0',
    rowGap: '24px',
    '&:empty': { paddingBottom: 0 },
  },
  terms: {
    '&>p': {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: theme.evPalette.charcoal[900],
    },
  },
  button: {
    height: '44px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
  },
  orderDetailLoader: {
    display: 'flex',
    padding: '16px 24px',
    alignItems: 'flex-start',
    gap: '24px',
    borderRadius: '4px',
    flexDirection: 'row',
    '@media (max-width: 640px)': {
      flexDirection: 'column',
    },
  },
  orderDetailLoaderGrid: {
    flexDirection: 'column',
    width: '50%',
    paddingBottom: '0px',
    gap: '24px',
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },
  orderDetailLoaderSkeletonA: {
    height: '18px',
    width: '76px',
    borderRadius: '6px',
  },
  orderDetailLoaderPaymentSkeleton: {
    height: '24px',
    borderRadius: '6px',
    maxWidth: '592px',
  },
  orderDetailLoaderPaymentSkeletonA: {
    height: '24px',
    width: '287px',
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      flex: '1 0 0',
    },
  },
  orderDetailLoaderSummaryGrid: {
    gap: '10px',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    justifyContent: 'space-between',
  },
  orderDetailLoaderSummaryGridA: {
    gap: '10px',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    padding: '20px 0px',
    borderTop: '1px solid #B4BAC7',
    borderBottom: '1px solid #B4BAC7',
  },
  emailRecipientsSkeleton: {
    height: '41px',
    width: '464px',
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },
}));
